import React, { Component } from "react"
import ReactTable from "react-table";
import { Configurations } from '../../Utils/Configurations';
import { BuscaOrganizacao } from 'ebs-orders-reports-react-lib';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import axios from 'axios';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';


class LocationInfoOrganizations extends Component {

    constructor(props) {
        super(props);

        this.handleOrg = this.handleOrg.bind(this);
        this.cadastrarOrganizacao = this.cadastrarOrganizacao.bind(this);
        this.carregaListaOrganizacoesCadastradas = this.carregaListaOrganizacoesCadastradas.bind(this);
        this.excluirOrganizacao = this.excluirOrganizacao.bind(this);
        this.toggleModalExcluirOrganizacao = this.toggleModalExcluirOrganizacao.bind(this);
        this.toggleModalSucessoOrganizacaoCadastrada = this.toggleModalSucessoOrganizacaoCadastrada.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);



        this.Configurations = new Configurations();


        this.state = {
            organizacoesCadastradas: [],
            isLoadingCadastrarOrganizacao: false,
            isOpenModalExcluirOrganizacao: false,
            isLoadingExcluir: false
        }

        this.columns = [
            {
                Header: "#",
                accessor: "idOrganizacao",
                className: "text-center pointer",
                width: 60
            },
            {
                Header: "Coord. Geral",
                accessor: "coordGeral",
                className: "text-center pointer",
                width: 130,
            },
            {
                Header: "Coordernadoria",
                accessor: "coordenadoria",
                className: "text-center pointer",
                width: 130,
            },
            {
                Header: "Subcoord.",
                accessor: "sub",
                className: "text-center pointer",
                width: 150,
            },
            {
                Header: "RM/RE",
                accessor: "rm",
                className: "text-center pointer",
            },
            {
                Header: "Regional",
                accessor: "regional",
                className: "text-center pointer",
            },
            {
                Header: "Distrito",
                accessor: "distrito",
                className: "text-center pointer",
            },
            {
                Header: "Comunidade",
                accessor: "comunidade",
                className: "text-center pointer",
            },
            {
                Header: "Bloco",
                accessor: "bloco",
                className: "text-center pointer",
            },
            {
                Header: '',
                className: 'pointer text-center text-danger',
                Cell: row => (<div onClick={() => this.toggleModalExcluirOrganizacao(row.original.idOrganizacao)}><i className="far fa-trash-alt"></i></div>),
            }
        ]
    }

    componentWillMount() {
        this.carregaListaOrganizacoesCadastradas();
    }

    handleOrg(eValue) {
        this.setState({ isLoadingOrganizacoes: true, orgSelecionada: eValue, flagBusca: true, });
    }

    carregaListaOrganizacoesCadastradas(value) {
        this.setState({ isLoadingOrganizacoesCadastradas: true })
        axios.get(this.Configurations.apiBasePath + `/logistica/locais-entrega/organizacoes/${this.props.match.params.idLocal}`).then(response => {
            this.setState({
                organizacoesCadastradas: response.data.organizacoesLocalEntrega,
                local: response.data.nomeLocalEntrega,
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingOrganizacoesCadastradas: false }))
    }

    cadastrarOrganizacao() {
        this.setState({ isLoadingCadastrarOrganizacao: true })
        const _body = {
            id: this.state.orgSelecionada,
            idLocalEntrega: this.props.match.params.idLocal
        }
        axios.post(this.Configurations.apiBasePath + `/logistica/locais-entrega/organizacao/novo`, _body).then(response => {
            this.carregaListaOrganizacoesCadastradas(true);
            this.toggleModalSucessoOrganizacaoCadastrada();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingCadastrarOrganizacao: false }))
    }

    excluirOrganizacao() {
        this.setState({ isLoadingExcluir: true })
        const _body = {
            idLocalEntrega: Number(this.props.match.params.idLocal),
            id: this.state.idOrganizacaoExcluida
        }
        axios.put(this.Configurations.apiBasePath + `/logistica/locais-entrega/organizacao/delete`, _body).then(response => {
            this.setState({
                idOrganizacaoExcluida: null
            }, () => this.toggleModalExcluirOrganizacao())
            this.carregaListaOrganizacoesCadastradas();
        }).catch(this.handleError).finally(this.setState({ isLoadingExcluir: false }))
    }

    toggleModalExcluirOrganizacao(id) {
        this.setState({
            idOrganizacaoExcluida: id,
            isOpenModalExcluirOrganizacao: !this.state.isOpenModalExcluirOrganizacao,
        })
    }
    handleError(err) {
        console.log("Erro inesperado", err);
        this.setState({
            hasError: true, errorMessage: (err.response && err.response.data && !!err.response.data.message) ?
                err.response.data.message : 'Erro inesperado.'
        })
    }

    toggleModalSucessoOrganizacaoCadastrada() {
        this.setState({
            modalSucessoOrganizacaoCadastrada: !this.state.modalSucessoOrganizacaoCadastrada
        })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    render() {
        const { orgSelecionada } = this.state;
        return (
            <div className="row logistics">
                <div className="col-12">
                    <div className="row">
                        <div className="col-10">
                            <h2>Nome do local: {this.state.local} - Organizações</h2>
                        </div>
                        <div className="col-2  text-right">
                            <button className="btn btn-outline-secondary" onClick={() =>
                                window.history.go(-1)}> voltar</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-12 pt-2 pb-1">
                                    <p className="m-0">Selecione a organização a ser cadastrada:</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-9 py-1 px-2">
                                    <BuscaOrganizacao handleOrg={this.handleOrg} orgSelecionada={orgSelecionada} apiBasePath={this.Configurations.apiBasePath} tokenKey={this.Configurations.tokenKey} />
                                </div>
                                {this.state.isLoadingCadastrarOrganizacao ? (
                                    <div className="col-3 text-center">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : (
                                    <div className="col-3 text-right">
                                        <button className="btn btn-outline-success" disabled={!orgSelecionada} onClick={this.cadastrarOrganizacao}>cadastrar organização</button>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12">
                            <p className="m-0 mb-3 text-center ">Organizações cadastradas</p>
                            <div className="card">
                                <div className="card-body p-0">
                                    <ReactTable
                                        data={this.state.organizacoesCadastradas}
                                        columns={this.columns}
                                        defaultPageSize={20}
                                        pages={this.state.pages}
                                        manual
                                        className="-striped -highlight"
                                        headerClassName="ebs-table-header"
                                        previousText='Anterior'
                                        nextText='Próximo'
                                        loadingText='Carregando...'
                                        noDataText='Nenhuma organização encontrada.'
                                        pageText='Página'
                                        ofText='de'
                                        rowsText='linhas'
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <Modal isOpen={this.state.isOpenModalExcluirOrganizacao} toggle={this.toggleModalExcluirOrganizacao}>
                    <ModalHeader toggle={this.toggleModalExcluirOrganizacao}>Excluir organização</ModalHeader>
                    <ModalBody>
                        Deseja realmente excluir organização?
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingExcluir ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button color="danger" onClick={this.excluirOrganizacao}>Excluir</Button>
                        )}
                        {' '}<Button color="secondary" onClick={this.toggleModalExcluirOrganizacao}>Cancelar</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalSucessoOrganizacaoCadastrada} toggle={this.toggleModalSucessoOrganizacaoCadastrada}>
                    <ModalHeader toggle={this.toggleModalSucessoOrganizacaoCadastrada}>
                    </ModalHeader>
                    <ModalBody>
                        Organização cadastrada com sucesso!
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleModalSucessoOrganizacaoCadastrada}>ok</Button>
                    </ModalFooter>
                </Modal>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={!this.state.hasError}
                />
            </div>
        )
    }
}

export default LocationInfoOrganizations;